import { render, staticRenderFns } from "./BatteryGroup.vue?vue&type=template&id=118e9738&scoped=true&"
import script from "./BatteryGroup.vue?vue&type=script&lang=js&"
export * from "./BatteryGroup.vue?vue&type=script&lang=js&"
import style0 from "./BatteryGroup.vue?vue&type=style&index=0&id=118e9738&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118e9738",
  null
  
)

export default component.exports